/* eslint-disable no-unused-vars */
import { useRef, useState, useContext, useEffect, useCallback } from 'react';
import Filters from '../Filters/filters';
import CategoryList from '../CategoryList/categoryList';
import Button from '../../../Components/Button/button';
import {updateKpiDetails } from '../../../Api/request/manageKpi';
import { AuthContext } from '../../../Contexts/AuthContext';
import styles from './editKpi.module.scss';
import UseAxios from '../../../Api/http/http';
import {
  OOPS_TRY_AGAIN,
  AUTHENTICATION_FAILED,
  UPDATE,
  UPDATE_SUCCESS,
  MANAGE_KPI_DASHBOARD,
  SAVE,
  SAVE_SUCCESS,
} from '../../../Constants/strings';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { useLocation, useNavigate } from 'react-router-dom';

const EditKpi = () => {
  const kpiDetailsRefs = useRef([]);
  const { userProfile } = useContext(AuthContext);
  const { snackbarOpen } = useSnackbar();
  const [kpiVertical, setKpiVertical] = useState([]);
  const [kpiDepartment, setKpiDepartment] = useState([]);
  const [kpiDesignation, setKpiDesignation] = useState([]);
  const [shouldDisableButton, setShouldDisableButton] = useState(false);
  const location = useLocation();
  const [kpiDetails, setKpiDetails] = useState(location.state?.kpiDetails || []);
  const [kpiPerformance, setKpiPerformance] = useState([]);
  const navigate = useNavigate();
  const { showImage } = location.state || {};

  useEffect(() => {
    const storedKpiVertical = localStorage.getItem('kpiVertical');
    const storedKpiDepartment = localStorage.getItem('kpiDepartment');
    const storedKpiDesignation = localStorage.getItem('kpiDesignation');
    const storedKpiPerformance = localStorage.getItem('kpiPerformance');
    if (storedKpiVertical) {
      const parsedKpiVertical = JSON.parse(storedKpiVertical);
      setKpiVertical([parsedKpiVertical]);
    }
    if (storedKpiDepartment) {
      const parsedKpiDepartment = JSON.parse(storedKpiDepartment);
      setKpiDepartment([parsedKpiDepartment]);
    }
    if (storedKpiDesignation) {
      const parsedKpiDesignation = JSON.parse(storedKpiDesignation);
      setKpiDesignation([parsedKpiDesignation]);
    }
    if (storedKpiPerformance) {
      const parsedKpiPerformance = JSON.parse(storedKpiPerformance);
      setKpiPerformance([parsedKpiPerformance]);
    }
  }, []);

  useEffect(() => {
    const arraysOnly = Object.values(kpiDetails).filter(value => Array.isArray(value));
    const shouldDisable = arraysOnly.every(array =>
      array.length === 0
      || array.every(item => {
        if (!item.id) return true;

        const format = (typeof item.targetFormatId === 'object' && item.targetFormatId.format)
          ? item.targetFormatId.format
          : item.targetFormatId;

        return format === 'Yes/No'
          ? item.targetValue === ''
          : item.symbol === '' || item.symbolTargetValue === '';
      }),
    );
    setShouldDisableButton(shouldDisable);
  }, [kpiDetails]);

  const onKpiDetailsChange = useCallback(({ id, kpis }) => {
    setKpiDetails((prevKpiDetails) => ({
      ...prevKpiDetails,
      [id]: kpis,
    }));
  }, []);

  const getTargetFormatOperatorId = (item) => {
    if (typeof item.targetFormatId === 'object') {
      if (item.targetFormatId.format === 'Yes/No') {
        if (typeof item.targetValue === 'object') {
          return item.targetValue.kpiTargetFormatId;
        }
        return '';
      } else if (typeof item.symbol === 'object' || item.symbol) {
        const matchingOption = item.targetFormatId.options.find(
          (opt) => opt.combination === item.symbol.combination || opt.combination === item.symbol,
        );
        if (matchingOption) {
          return matchingOption.kpiTargetFormatId;
        }
      }
      return '';
    } else if (typeof item.symbol === 'object') {
      return item.symbol.kpiTargetFormatId;
    } else if (typeof item.targetValue === 'object') {
      return item.targetValue.kpiTargetFormatId;
    }
    return item.kpiFormatOpertorId;
  };

  const getTargetValue = (item) => {
    if (typeof item.targetFormatId === 'object' && item.targetFormatId.format === 'Yes/No') {
      return '';
    }
    return item.symbolTargetValue;
  };

  const getKpiId = (item) => {
    return typeof item.kpiId === 'object' ? item.kpiId?.id : item.kpiNameId;
  };

  const getKPIDetails = () => {
    const kpiDetailsCopy = { ...kpiDetails };
    const responseKeys = Object.keys(kpiDetailsCopy);

    responseKeys.forEach((key) => {
      if (!Array.isArray(kpiDetailsCopy[key])) {
        delete kpiDetailsCopy[key];
      }
    });

    return Object.entries(kpiDetailsCopy).flatMap(([key, valueArray]) => {
      return valueArray.map((item) => {
        const targetFormatOperatorId = getTargetFormatOperatorId(item);
        const targetValue = getTargetValue(item);
        const kpiId = getKpiId(item);

        return {
          kpiId: kpiId,
          targetFormatOperatorId: targetFormatOperatorId,
          targetValue: targetValue,
        };
      });
    });
  };

  const handleUpdate = async () => {

    const kpiDetailsArray = getKPIDetails();

    for (const item of kpiDetailsArray) {
      const { targetFormatOperatorId, targetValue } = item;

      if ((targetFormatOperatorId === '' || targetFormatOperatorId === undefined)
        || (targetFormatOperatorId && ![1, 2].includes(targetFormatOperatorId) && targetValue === '')
      ) {
        snackbarOpen(MANAGE_KPI_DASHBOARD.SET.FAILURE_REQUIRED_TARGET_VALUES, 'warning');
        return;
      }
    }
    const payload = {
      departmentId: kpiDepartment[0].id,
      verticalId: kpiVertical[0].id,
      designationId: kpiDesignation[0].id,
      performancePeriodId: kpiPerformance[0].id,
      kpiDetails: kpiDetailsArray,
      lastUpdatedBy: userProfile.user_name,
    };

    try {
      const response = await UseAxios(updateKpiDetails(payload));
      if (response.data.status !== 200){
        const errorStatus = response.data.response.status;
        snackbarOpen(
          errorStatus === 401
            ? AUTHENTICATION_FAILED
            : OOPS_TRY_AGAIN, 'warning');

        throw new Error('Failed to update KPI details');
      } else {
        snackbarOpen(!showImage ? UPDATE_SUCCESS : SAVE_SUCCESS, 'success');
        navigate('/configuration/manage-kpi');
      }
    } catch (error) {
      console.error('Failed to update KPI details:', error);
    }
  };

  return (
    <div className={styles.container}>
      <Filters
        isEdit={true}
        showImage={showImage}
      />
      <CategoryList
        kpiDetailsRefs={kpiDetailsRefs}
        isEdit={true}
        updateKpiDetails={onKpiDetailsChange}
        kpiDetails={kpiDetails}
      />
      <div className={styles['btn-container']}>
        <Button
          label={!showImage ? UPDATE : SAVE}
          variant="text"
          onClick={handleUpdate}
          btnCss={shouldDisableButton ? `${styles['update-btn']} ${styles.disabled}` : styles['update-btn']}
          disabled={shouldDisableButton}
        ></Button>
      </div>
    </div>
  );
};

export default EditKpi;
